// extracted by mini-css-extract-plugin
export default {"list":"dropdowns_list__bTGxF"};